import { useGLTF } from '@react-three/drei'
import { useEffect } from 'react'

export default function Table()
{
    const model = useGLTF('./models/furniture/painted_wooden_table/painted_wooden_table_1k.gltf')
    
    useEffect(() => {
        model.scene.traverse((child) => {
            if (child.isMesh) {
                child.castShadow = true
                child.receiveShadow = true
            }
        })
    }, [model])

    return <primitive
        object={model.scene}
        position-y={-2}
    />
}